// extracted by mini-css-extract-plugin
export default {"transfer":"OrderWindow_transfer__vritO","orderValue":"OrderWindow_orderValue__1k4nd"};